import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-front_page",
  "use": "icon-front_page-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"icon-front_page\">\n\t<path fill=\"none\" d=\"M0,0H24V24H0Z\" />\n\t<path d=\"M6,21a2,2,0,0,1-2-2V11.76a2,2,0,0,1,.51-1.33l6-6.75a2,2,0,0,1,2.82-.17,1.29,1.29,0,0,1,.16.17l6,6.75A2,2,0,0,1,20,11.76V19a2,2,0,0,1-2,2ZM12,5,6,11.76V19H9V14a1,1,0,0,1,1-1h4a1,1,0,0,1,1,1v5h3V11.76Zm1,10H11v4h2Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol